import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MenuQuestionComponent } from '../menu-question/menu-question.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { CdkDrag } from '@angular/cdk/drag-drop';

@Component({
    selector: 'que-free-text-question',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, CdkDrag,
        MenuQuestionComponent, TranslateDirective, TranslatePipe],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: FreeTextQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: FreeTextQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './free-text-question.component.html',
    styleUrls: ['./free-text-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FreeTextQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Output() focusEvent = new EventEmitter<boolean>();
  #builder = inject(FormBuilder);
  questionForm = this.#builder.group({
    id: [-1],
    type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
    title: new FormControl<string>('', [Validators.required]),
    text: new FormControl<string>(''),
    optionsList: new FormControl<OptionsList | null>(null),

    requierd: new FormControl<boolean>(false),
    collectionQuestionId: new FormControl<number | null>(null),
    stepId: [-1],

  });
  orginalQuestion?: Question;
  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    this.questionForm.disable();
    //because ther is tow inputs is about tow same field named text;
    this.questionForm.valueChanges.subscribe(question => {
      this.registerOnChangeCallback({...this.orginalQuestion, ...question });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.questionForm.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: Question): void {
    this.orginalQuestion = obj;
    this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }

}

